module.exports = __webpack_public_path__ + "static/media/cross_arm.167806d9.jpg";